import React from 'react';
import CardTemplateComponent from '../CardTemplate';
import {Icon} from '../../Common/Icon';
import { translate } from 'react-i18next';
import cx from '../../../styles';
import { gtmSend } from '../../../helpers';

const VideoCard = ({title, question, siteUrl, viewUrl, inFeed, video, ifShowVideo, onTitleClick, onPlayHandler, match, t, botIndex}) => {

    const handleContentClick = () => {
        if(inFeed)
        return onTitleClick();
        else
        return false;
    }

    let relValue = {};
    if(!botIndex){
        relValue = {
            rel: "nofollow"
        };
    }

    let titleHtml = "";
    if(title) {
        if(inFeed) {
            titleHtml = <p className={cx("page-title", "pointer-click")} onClick={() => {handleContentClick(); gtmSend('dynamic', 'Video Card', 'click-title-click', match.path)}}>
                            <a href={siteUrl + viewUrl} {...relValue} dangerouslySetInnerHTML={{__html: title}} onClick={(e) => e.preventDefault()}></a>
                        </p>
        }
        else {
            titleHtml = <h1 className={cx("page-title")} dangerouslySetInnerHTML={{__html: title}}></h1>
        }
    }

    let mainContentHtml = "";
    if(question){
        if(!title && !inFeed) {
            mainContentHtml = <h1 dangerouslySetInnerHTML={{__html: question}}></h1>
        }
        else if(title && !inFeed) {
            mainContentHtml = <p dangerouslySetInnerHTML={inFeed ? {__html: question.replace(/^\s*[\r\n]/gm, '')} : {__html: question}}></p>
        }
        else{
            mainContentHtml = <p className={cx(inFeed && (question.length > 300 || question.split(/\r\n|\r|\n/).length > 3) ? "content-text-crop" : "")} onClick={() => {handleContentClick(); gtmSend('dynamic', 'Video Card', 'click-question-click', match.path)}}>
                                <a className={cx('question-card-link')} href={siteUrl + viewUrl} {...relValue} dangerouslySetInnerHTML={inFeed ? {__html: question.replace(/^\s*[\r\n]/gm, '')} : {__html: question}} onClick={(e) => e.preventDefault()}></a>
                              </p>
        }
    }

    return (
        <div className={cx("question-elements", "video-card")}>
            {titleHtml}

            <div className={cx("text-desc")}>
                { mainContentHtml }
                
                { inFeed && question && (question.length > 300 || question.split(/\r\n|\r|\n/).length > 3) && <a className={cx('read-more-link')} href={siteUrl + viewUrl}>{t('lp_read_more')}</a> }
            </div>

            <section>
                <div className={cx("link-share-card")}>
                    {
                        !ifShowVideo
                        ?
                        <div className={cx("bg-img")} style={{backgroundImage: `url(${video.thumbnail})`}}>
                            <div>
                                <button className={cx("btn", "btn-round")} onClick={onPlayHandler}>
                                    <Icon name="play-regular-white-md" />
                                </button>
                            </div>
                        </div>
                        :
                        <iframe id="ytplayer" type="text/html" width="320" height="240"
                            src={'https://www.youtube.com/embed/' + video.id + '?autoplay=1'}
                            frameBorder="0" title="video card"></iframe>
                    }
                    <a href={'https://www.youtube.com/embed/' + video.id} target="_blank" rel="noopener noreferrer" className={cx('video-title-desc')}>
                        <span className={cx('video-title')}>{video.title}</span>
                        <span className={cx('video-desc')}>{video.description}</span>
                    </a>
                </div>
            </section>
        </div>
    );
}

const VideoCardComponent = CardTemplateComponent(VideoCard);

export default translate()(VideoCardComponent);
